export const isValidKeyValue = (key: string, value: any): boolean => {
  const isNumber = (x: number) => typeof x === "number";

  const methods = {
    page: isNumber,
    size: isNumber,
    total: isNumber
  };

  return methods[key] && methods[key](value);
};
